import Avatar1 from "../../assets/avatar1.jpg";
import Avatar2 from "../../assets/avatar2.png";
import Avatar3 from "../../assets/avatar3.jpg";

const data = [
  {
    id: 1,
    quote:
      "It is truly amazing how Emmanuel delivered exactly what I envisioned with minimal guidance. His ability to translate brief requirements into a high-quality product is outstanding. He is well on his way to becoming a top-tier Front-End Developer. Best of Luck !!",
    avatar: Avatar1,
    name: "M. Sunil Kumar",
    profession: "Manager/Tutor",
  },
  {
    id: 2,
    quote:
      "Great job, Emmanuel! I was impressed by how you successfully translated your learning into full-scale, practical projects. It was a pleasure mentoring you, and your ability to apply complex concepts is commendable.Best of luck !!",
    avatar: Avatar2,
    name: "Pavan Kumar",
    profession: "Full Stack Java Developer/Mentor",
  },
  {
    id: 3,
    quote:
      "Impressive work, bro!. And thank you for building a Managment system where I can store the data/ record the data regarding my patients for free of cost.",
    avatar: Avatar3,
    name: "Dr. Christina Emmanuel",
    profession: "Doctor(P.H.C)",
  },
];

export default data;
